"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 计算真实发送的metric和通过计算得出的关联的已上报metric
// @return [{ actual: 'metric', relevant: ['metric1', 'metric2'] }]
var _default = function _default(cacheMetric, scoreList) {
  var scoreStruct = {};
  var metricData = [];

  // 第一步先定义出一个与scoreList相同结构的对象
  Object.keys(scoreList).forEach(function (item) {
    scoreStruct[item] = -1;
  });

  // 第二步找到cacheMetric在每个scoreList中的最大的index
  cacheMetric.forEach(function (cache) {
    Object.keys(scoreList).forEach(function (score) {
      var i = scoreList[score].indexOf(cache);
      scoreStruct[score] = Math.max(scoreStruct[score], i);
    });
  });

  // 第三步找到真实的需要发送的metric以及关联的metric
  Object.keys(scoreStruct).forEach(function (item) {
    var o = {
      actual: '',
      relevant: []
    };
    o.actual = scoreList[item][scoreStruct[item]];
    o.relevant = scoreList[item].slice(0, scoreStruct[item] + 1);
    metricData.push(o);
  });
  return metricData;
};
exports.default = _default;